export const GET_INTERNATIONAL_TEAM_DATA_REQUEST = 'GET_INTERNATIONAL_TEAM_DATA_REQUEST';   
export const GET_INTERNATIONAL_TEAM_DATA_SUCCESS = 'GET_INTERNATIONAL_TEAM_DATA_SUCCESS';
export const GET_INTERNATIONAL_TEAM_DATA_FAILURE = 'GET_INTERNATIONAL_TEAM_DATA_FAILURE';

export const GET_WOMEN_TEAM_DATA_REQUEST = 'GET_WOMEN_TEAM_DATA_REQUEST';
export const GET_WOMEN_TEAM_DATA_SUCCESS = 'GET_WOMEN_TEAM_DATA_SUCCESS';
export const GET_WOMEN_TEAM_DATA_FAILURE = 'GET_WOMEN_TEAM_DATA_FAILURE';

export const GET_IPL_TEAM_DATA_REQUEST = 'GET_IPL_TEAM_DATA_REQUEST';
export const GET_IPL_TEAM_DATA_SUCCESS = 'GET_IPL_TEAM_DATA_SUCCESS';
export const GET_IPL_TEAM_DATA_FAILURE = 'GET_IPL_TEAM_DATA_FAILURE';

export const GET_ARTICLES_DATA_REQUEST = 'GET_ARTICLES_DATA_REQUEST';
export const GET_ARTICLES_DATA_SUCCESS = 'GET_ARTICLES_DATA_SUCCESS';
export const GET_ARTICLES_DATA_FAILURE = 'GET_IPL_TEAM_DATA_FAILURE';